// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "BusinessProVisitorLazyComponent" + "." + "af25ee93e7f66bbecbc7" + ".css";
};